<template>
  <div>
    <cashback-intro v-if="!isActivated && !userBlocked" @activated="onActivated" @show-how-it-works="showHowItWorks = true" />
    <cashback-main v-else :user-blocked="userBlocked" :user-verified="IsVerified" @show-how-it-works="showHowItWorks = true" @redeem-result="onRedeemResult" />

    <cashback-how-it-works-modal v-if="showHowItWorks" @close="showHowItWorks = false" />

    <cashback-result-modal v-if="redeemModal" :type="redeemModal.type" :message="redeemModal.message" @close="redeemModal = null" />
  </div>
</template>

<script>
import CashbackIntro from '@/components/cashback/CashbackIntro.vue'
import CashbackMain from '@/components/cashback/CashbackMain.vue'
import CashbackHowItWorksModal from '@/components/cashback/CashbackHowItWorksModal.vue'
import CashbackResultModal from '@/components/cashback/CashbackResultModal.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    CashbackIntro,
    CashbackMain,
    CashbackHowItWorksModal,
    CashbackResultModal,
  },
  data() {
    return {
      showHowItWorks: false,
      redeemModal: null,
    }
  },
  computed: {
    ...mapGetters({
      UserInfo: 'user/info',
      IsVerified: 'user/isVerified',
    }),
    userBlocked() {
      if (!this.UserInfo.client) return false
      return this.UserInfo.client.cashback_status === 2
    },
    isActivated: {
      get() {
        if(!this.UserInfo.client) return false
        return this.UserInfo.client.cashback_status === 1
      },
      set(value) {
        this['user/setInfo']({ ...this.UserInfo, client: { ...this.UserInfo.client, cashback_status: value } })
      },
    },
  },
  mounted() {},
  methods: {
    onActivated() {
      this.isActivated = 1
      this.$toasted.success(this.$t('cashback_apply_success'))
    },
    onRedeemResult(type) {
      const messages = {
        success: this.$t('cashback_redeem_success'),
        error: this.$t('cashback_redeem_error'),
        unavailable: this.$t('cashback_redeem_unavailable'),
      }
      this.redeemModal = {
        type: type === 'success' ? 'success' : type === 'unavailable' ? 'unavailable' : 'error',
        message: messages[type] || messages.error,
      }
    },
    ...mapActions(['user/setInfo']),
  },
}
</script>
